import type { ReactNode } from 'react'
import { twJoin } from 'tailwind-merge'

type Props = {
  left: ReactNode
  right?: ReactNode
  className?: string
}

export function FormActionBar({ left, right, className }: Props) {
  if (!left && !right) {
    return null
  }

  return (
    <div
      className={twJoin(
        'flex flex-wrap items-center justify-between gap-4 rounded-md bg-gray-50 p-3 ring-1 ring-gray-900/5',
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-4">{left}</div>
      {right && <div className="flex min-w-0 items-center gap-4">{right}</div>}
    </div>
  )
}
